import { useQuery } from "@tanstack/react-query";
import { getTaskImages } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getTaskImagesQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

export function useTaskImages(taskId: string | null) {
  return useQuery({
    queryKey: getTaskImagesQueryKey(taskId),
    queryFn: () => getTaskImages(taskId!),
    enabled: taskId !== null,
    placeholderData:
      createPreviousOnNullPlaceholderDataFn<SignedUpload[]>(taskId),
  });
}
